import React from 'react';
import {
  Route,
  BrowserRouter as Router,
  Switch
} from "react-router-dom";
import Loader from '../components/basic/loader';
import { Popup } from '../components/basic/popup';
import * as Routes from '../constants/routes';
import { MainContextProvider, TermsAndConditionsProvider } from "../context";
import { AppData } from '../data';
import { GradProductsPage } from "../pages/gradProducts";
import { HomePage } from '../pages/home';

const App = () => {

  return (
    <Router>
      <MainContextProvider>
        <TermsAndConditionsProvider>
          <Loader />
          <Popup />
          <Switch>
            <Route path={Routes.HOME}>
              {AppData?.isSchoolStorePage ? <HomePage appData={AppData} /> : <GradProductsPage appData={AppData} />}
            </Route>
          </Switch>
        </TermsAndConditionsProvider>
      </MainContextProvider>
    </Router>
  )
}

export default App
